import { render, staticRenderFns } from "./AddProvideProduct.vue?vue&type=template&id=4e17e38e&scoped=true"
import script from "./AddProvideProduct.vue?vue&type=script&lang=js"
export * from "./AddProvideProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e17e38e",
  null
  
)

export default component.exports